import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import performRequest from "../../api/request";
import SimpleButton from "../../Components/layouts/simple_button";
import { LeadInfo } from "../../SchemaInfo/info";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useNavigate } from "react-router";
import { IoCall } from "react-icons/io5";
import getFilteredURL from "../../Components/Functions/filters.getUrl";

const SideBar = () => {
  const store = useSelector((store) => store.login.user);
  const [modalData, setModalData] = useState(null);
  const [missedCallData, setMissedCallData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [currentUser, setCurrentUser] = useState(store?.Name || "");
  const [loading, setLoading] = useState(false);
  const [newEnquires, setNewEnquires] = useState();

  const navigate = useNavigate();

  const getName = (lead) => {
    return (
      lead?.fullName ||
      `${lead?.firstName || ""} ${lead?.lastName || ""}`.trim() ||
      "N/A"
    );
  };

  const AddAndAssignLead = (values) => {
    if (!values) return;
    let lead = {
      ...LeadInfo,
      first_name: values.firstName || values.fullName || "",
      last_name: values.lastName || "",
      full_name: getName(values),
      company_name: values.businessName || "",
      lead_genrated_from: "enquiry",
      lead_alloted_to: store.Name || "",
      reAssignTo: store.Name || "",
      phone_number: values.mobileNumber || values.whatsappNumber || "",
      email: values.email || "",
      gst_number: values.gst_number || "",
      address: values.address1 || values.address2 || "",
      notes: values.notes || "",
    };

    setLoading(true);
    performRequest("POST", "/leads/createleads", lead)
      .then((res) => {
        if (res.status === 201) {
          document.getElementById("canvasClose").click();
          Toast("success", "Lead generated successfully!");
          setRefresh(!refresh);
          setTimeout(() => {
            navigate(`/leads/edit-lead/${res.data.id}`);
          }, 300);
        } else if (res.status === 200) {
          Toast("error", res.data.message);
          if (res.data.id) {
            navigate(`/leads/edit-lead/${res.data.id}`);
          }
          setRefresh(!refresh);
        } else {
          Toast("error", res.data.message || "Error while uploading");
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        CustomErrorResponse("Error", err);
      })
      .finally(() => setLoading(false));
  };

  const handleCall = (phoneNumber) => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    } else {
      alert("Phone number is not available!");
    }
  };

  useEffect(() => {
    if (
      currentUser &&
      store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
      store.Role !== process.env.REACT_APP_ROLE_IT
    ) {
      performRequest(
        "GET",
        `/enquiryWebhook/getMyoperatorDataByUserName/${currentUser}`
      )
        .then((res) => {
          if (res.status === 200) {
            setMissedCallData(res?.data?.getMyOperatorData || []);
          }
        })
        .catch((err) => console.error(err));
    }
  }, [currentUser, refresh]);

  useEffect(() => {
    if (
      currentUser &&
      store.Role !== process.env.REACT_APP_ROLE_CLIENT &&
      store.Role !== process.env.REACT_APP_ROLE_IT
    ) {
      performRequest(
        "GET",
        getFilteredURL("/allTablesCount/getTableCountByNameNew/", 1, {
          generatedby: currentUser,
        })
      )
        .then((res) => {
          if (res.status === 200) {
            setNewEnquires(res?.data?.todaysEnquiry);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [currentUser, refresh]);

  return (
    <>
      <button
        className="d-print-none"
        style={styles.floatingButton}
        data-bs-toggle="offcanvas"
        href="#offcanvasEnd"
        role="button"
        aria-controls="offcanvasEnd"
      >
        Missed Calls
        <span className="badge bg-red text-red-fg badge-notification badge-pill me-3 mt-1">
          {missedCallData?.length}
        </span>
      </button>
      <div
        className="modal modal-blur fade"
        id="modal-missed"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Filter lead</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {modalData && (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Full name</label>
                    <div className="w-100 col">
                      {(
                        modalData?.fullName ||
                        modalData?.firstName ||
                        "N/A"
                      ).toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Address</label>
                    <div className="w-100 col">
                      {(
                        modalData.address1 ||
                        modalData.address2 ||
                        "N/A"
                      ).toUpperCase()}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Email Address
                    </label>
                    <div className="w-100 col">{modalData?.email || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Phone Number
                    </label>
                    <div className="w-100 col">
                      {modalData?.mobileNumber || modalData?.whatsappNumber ? (
                        <span
                          onClick={() =>
                            handleCall(
                              modalData?.mobileNumber ||
                                modalData?.whatsappNumber
                            )
                          }
                          className="cursor-pointer text-blue text-decoration-underline"
                        >
                          <svg
                            color="green"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-phone-outgoing"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
                            <path d="M15 9l5 -5" />
                            <path d="M16 4l4 0l0 4" />
                          </svg>

                          {modalData?.mobileNumber || modalData?.whatsappNumber}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {/* <div className="mb-3 row d-lg-none d-md-none">
                    <label className="w-25 form-label col-3">Call Now</label>
                    <div className="w-100 col">
                      <SimpleButton buttonText="Call Now" />
                    </div>
                  </div> */}
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Lead Generated From
                    </label>
                    <div className="w-100 col">
                      {(modalData?.origin || "N/A").toUpperCase()}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              <div>
                <SimpleButton
                  buttonText="Not Connected"
                  type="secondary"
                  data-bs-dismiss="modal"
                />
              </div>

              <SimpleButton
                onClick={() => {
                  AddAndAssignLead(modalData);
                }}
                buttonText="Call Connected"
                data-bs-dismiss="modal"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="offcanvasEnd"
        aria-labelledby="offcanvasEndLabel"
      >
        <div className="offcanvas-header">
          <h2 className="offcanvas-title" id="offcanvasEndLabel">
            <IoCall className="fs-1 me-2" />
            Missed Calls
          </h2>
          <button
            type="button"
            id="canvasClose"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body p-0 m-0">
          <div className="card-table table-responsive">
            <table className="table table-vcenter">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Contact Number</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {missedCallData?.length == 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      <p className="m-0">
                        No missed calls. Complete enquiries!
                      </p>
                    </td>
                  </tr>
                ) : (
                  missedCallData?.map((followup, index) => (
                    <tr key={followup.id}>
                      <td>{index + 1}</td>
                      <td>{followup?.mobileNumber || "N/A"}</td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm px-3"
                          data-bs-dismiss="offcanvas"
                          disabled={!followup?.mobileNumber}
                          data-bs-toggle="modal"
                          data-bs-target="#modal-missed"
                          onClick={() => setModalData(followup)}
                        >
                          Assign To Me
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {missedCallData?.length < 10 && (
            <div className="card-table table-responsive">
              <table className="table table-vcenter">
                <thead>
                  <tr>
                    <th>Sr</th>
                    <th>Contact Number</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {newEnquires?.map((followup, index) => (
                    <tr key={followup.id}>
                      <td>{index + 1}</td>
                      <td>{followup?.mobileNumber || "N/A"}</td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm px-3"
                          data-bs-dismiss="offcanvas"
                          disabled={!followup?.mobileNumber}
                          data-bs-toggle="modal"
                          data-bs-target="#modal-missed"
                          onClick={() => setModalData(followup)}
                        >
                          Assign To Me
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const styles = {
  floatingButton: {
    position: "fixed",
    bottom: "10px",
    right: "10px",
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    fontSize: "16px",
    transition: "all 0.3s ease",
  },
};

export default SideBar;
